module.exports = __webpack_public_path__ + "static/media/new-goal-icon.a2e26931.svg";